module.exports = __webpack_public_path__ + "img/golden_line_up@2x.4e7da3b3.png";